function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('.autoplaying-video')) {
      video.pause();
    }
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    } 
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateLabel();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
 
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    // Check if isQuickAddModal is true and return false to prevent execution
    if (window.isQuickAddModal) {
      return false;
    }    
    
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateLabel() {
      const label = document.getElementById('colorSwatchLabel');
      if (!label) return;
  
      const wrapper = document.querySelector('.radio-options-wrapper');
      if (!wrapper) return;
  
      const colorInput = wrapper.querySelector('.option-color-picker-wrapper input[type="radio"]:checked');
      if (!colorInput) return;
  
      label.innerHTML = colorInput.value;
  }
 
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const galSource = html.getElementById(`pageGallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const galDestination = document.getElementById(`pageGallery-${this.dataset.section}`);


        if (galSource && galDestination && this.currentVariant.featured_media) {
          galDestination.innerHTML = galSource.innerHTML;
        }
        
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        // Re-initiate slider handleScroll function
        const slidesContainer = document.getElementById('SlidesCon');
        const leftArrow = document.querySelector('.gallery-slider-arrows .slider-arrow-left');
        const rightArrow = document.querySelector('.gallery-slider-arrows .slider-arrow-right');
        
        if (slidesContainer) {
          slidesContainer.addEventListener('scroll', function() {
            handleScroll(); // Call handleScroll function
          });
        }

        // Re-initiate sliderArrows function
        if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          slidesContainer.scrollBy({
            left: -300,
            behavior: 'smooth'
          });
        });
        }
        if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          slidesContainer.scrollBy({
            left: 300,
            behavior: 'smooth'
          });
        });
        }      

        // Re-initialize the thumbnail scroll function
        if (!window.isQuickAddModal) {
          thumbnailsScroll();
        }
        
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });

    
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}


customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// Accordion Component
document.addEventListener("DOMContentLoaded", function () {
  // Get all elements with class "accordion-title"
  var headings = document.querySelectorAll(".accordion-title");

  // Loop through each heading element
  headings.forEach(function (heading) {
    // Get the corresponding panel
    var panel = heading.nextElementSibling;

    // Temporarily disable transitions for initialization
    panel.style.transition = "none";

    // Check if the panel is open by default
    if (panel.classList.contains("panel-open")) {
      // Set height to match content for open panels
      panel.style.height = panel.scrollHeight + "px";
    }

    // Re-enable transitions after initialization
    setTimeout(() => {
      panel.style.transition = ""; // Remove inline transition style
    });

    // Add a click event listener to each accordion heading
    heading.addEventListener("click", function () {
      if (panel.classList.contains("panel-open")) {
        // Close the panel
        panel.style.height = null;
        panel.classList.remove("panel-open");
        panel.setAttribute("aria-hidden", "true");
        heading.classList.remove("active");
        heading.setAttribute("aria-expanded", "false");
      } else {
        // Open the panel
        panel.style.height = panel.scrollHeight + "px";
        panel.classList.add("panel-open");
        panel.setAttribute("aria-hidden", "false");
        heading.classList.add("active");
        heading.setAttribute("aria-expanded", "true");
      }
    });
  });
});



// Slider Component

function LuxeSlider() {
  const sliderWrappers = document.querySelectorAll('.slider-outer-wrapper');

  sliderWrappers.forEach(wrapper => {
    const sliderContainer = wrapper.querySelector('.slider-element');
    const leftArrow = wrapper.querySelector('.slider-arrows .slider-arrow-left');
    const rightArrow = wrapper.querySelector('.slider-arrows .slider-arrow-right');
    
    function setArrowState() {
      // Find the first image element within the slider-element
      const firstImage = sliderContainer.querySelector('img');
      const placeholder = sliderContainer.querySelector('.global-image-placeholder');
    
      let imageHeight = 0;
      if (firstImage) {
        // Get the height of the first image
        imageHeight = firstImage.clientHeight;
      } else if (placeholder) {
        // If there is no image but a placeholder, get its height
        imageHeight = placeholder.clientHeight;
      }
      
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;
      const scrollLimitWithOffset = scrollLimit - 1;

      // Apply top margin to arrows based on half of the image height
      if (wrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0 && !Shopify.designMode) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }
      
      if (leftArrow && rightArrow) {
        if (scrollPosition === 0) {
          leftArrow.classList.add('disabled');
        } else {
          leftArrow.classList.remove('disabled');
        }
  
        if (scrollPosition === scrollLimit || scrollPosition >= scrollLimitWithOffset) {
          rightArrow.classList.add('disabled');
        } else {
          rightArrow.classList.remove('disabled');
        }
      }
    }

    sliderContainer.addEventListener('scroll', setArrowState);

    // Set initial arrow state
    setArrowState();
    
    // Event listener for window resize
    window.addEventListener('resize', setArrowState);

    if (leftArrow) {
    leftArrow.addEventListener('click', () => {
      sliderContainer.scrollBy({
        top: 0,
        left: -280,
        behavior: 'smooth'
      });
    });
    }
    if (rightArrow) {
    rightArrow.addEventListener('click', () => {
      sliderContainer.scrollBy({
        top: 0,
        left: 280,
        behavior: 'smooth'
      });
    });
    }
  });
}

// Call the function when the DOM is ready
document.addEventListener('DOMContentLoaded', LuxeSlider);



// Video

document.addEventListener('DOMContentLoaded', function() {

  // Function to pause all media except those within autoplaying-video div
  function pauseOtherMedia(except) {
  var mediaElements = document.querySelectorAll('video, audio');
  mediaElements.forEach(function(media) {
    if (media !== except && !media.closest('.autoplaying-video')) {
      media.pause();
    }
  });

  // Pause all embedded YouTube and Vimeo videos
  document.querySelectorAll('.iframe-youtube').forEach((video) => {
  video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.evp-vimeo iframe').forEach((iframe) => {
    if (iframe.closest('.evp-vimeo')) {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  });
}

  // Add click event listener to all video player posters
  document.querySelectorAll('.video-player-sh--poster').forEach(function(poster) {
    poster.addEventListener('click', function() {
      // Hide the poster
      poster.classList.add('poster-hidden');

      // Find the associated video element
      var video = poster.nextElementSibling;

      // Pause all other media except current video
      pauseOtherMedia(video);

      // window.pauseAllMedia();

      // Play current video
      video.play();
      video.controls = true;
    });
  });

  // Add event listener for playing media elements
  document.addEventListener('play', function(event) {
    var playingMedia = event.target;

    // Pause all other media except playing media element
    if (!playingMedia.closest('.autoplaying-video')) {
      pauseOtherMedia(playingMedia);
    }
  }, true); // Use capture phase to ensure event is caught before bubbling
});


// Hotspots

const hotspotButtons = document.querySelectorAll('.hotspot-button');

hotspotButtons.forEach(button => {
  button.addEventListener('click', () => {
    // Close all other open hotspot-info panels
    const allHotspotInfos = document.querySelectorAll('.hotspot-info');
    allHotspotInfos.forEach(info => {
      info.classList.remove('open');
      info.classList.add('hidden');
    });

    // Find the next sibling element with the class 'hotspot-info'
    const hotspotInfo = button.nextElementSibling;

    // Check if the next sibling is the .hotspot-info and add the 'open' class
    if (hotspotInfo && hotspotInfo.classList.contains('hotspot-info')) {
      hotspotInfo.classList.add('open');
      hotspotInfo.classList.remove('hidden');
    }

    // Find the close button within the hotspot-info and add a click event listener
    const closeButton = hotspotInfo.querySelector('.hotspot-close-button');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        // Remove the 'open' class when the close button is clicked
        hotspotInfo.classList.remove('open');
        hotspotInfo.classList.add('hidden');
      });
    }
  });
});


// Mobile slides layout

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mobile-slides-grid').forEach(mobileSlidesGrid => {
    const section = mobileSlidesGrid.closest('.section-inner');
    if (!section) return;

    const paginationOuter = section.querySelector('.slider-mobile-pagination-container');
    const paginationContainer = section.querySelector('.slider-mobile-pagination');
    const paginationMarkers = section.querySelectorAll('.pagination-marker');
    const gridItems = section.querySelectorAll('.mobile-slides-grid-item');

    if (paginationMarkers.length > 0 && gridItems.length > 0) {
      const totalItems = gridItems.length;
      const totalPages = paginationMarkers.length;
      const maxMarkersInView = 5;
      const markerWidth = paginationMarkers[0].offsetWidth;

      const computedStyle = window.getComputedStyle(paginationContainer);
      const markerGap = parseInt(computedStyle.getPropertyValue('column-gap') || computedStyle.getPropertyValue('gap') || '0', 10);

      let timeoutId;

      const updatePagination = () => {
        const scrollLeft = mobileSlidesGrid.scrollLeft;
        const scrollWidth = mobileSlidesGrid.scrollWidth;
        const clientWidth = mobileSlidesGrid.clientWidth;
        const maxScrollLeft = scrollWidth - clientWidth;

        const scrollPercentage = scrollLeft / maxScrollLeft;
        const currentPage = Math.round(scrollPercentage * (totalPages - 1));

        paginationMarkers.forEach(marker => marker.classList.remove('active'));
        if (paginationMarkers[currentPage]) {
          paginationMarkers[currentPage].classList.add('active');
        }

        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          if (currentPage >= 2 && currentPage <= totalPages - 3) {
            const offset = (currentPage - 2) * (markerWidth + markerGap);
            paginationContainer.style.transform = `translateX(-${offset}px)`;
          } else if (currentPage < 2) {
            paginationContainer.style.transform = `translateX(0)`;
          } else if (currentPage >= totalPages - 2) {
            const offset = (totalPages - maxMarkersInView) * (markerWidth + markerGap);
            paginationContainer.style.transform = `translateX(-${offset}px)`;
          }
        }, 15);
      };

      mobileSlidesGrid.addEventListener('scroll', updatePagination);
      window.addEventListener('resize', updatePagination);
      updatePagination();      
            
    }
  });
});


// Swipable product cards

function updateCardArrowState(arrowLeft, arrowRight, swipeTrack) {
  const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
  const buffer = 2; // Small buffer to account for rounding

  // Add 'faded' class if scroll is at the start or end
  if (swipeTrack.scrollLeft <= 0) {
    arrowLeft.classList.add('faded');
  } else {
    arrowLeft.classList.remove('faded');
  }

  if (swipeTrack.scrollLeft >= maxScrollLeft - buffer) {
    arrowRight.classList.add('faded');
  } else {
    arrowRight.classList.remove('faded');
  }
}

function initializeSwipeFunctionality(container = document) {

  // Swipable product cards - card media pagination
  document.querySelectorAll('.card-product--image-swipe-container').forEach(function (container) {
    const swipeTrack = container.querySelector('.card-product--image-swipe-track');
    const bullets = container.querySelectorAll('.product-card--pagination-bullet');
    const slides = swipeTrack.querySelectorAll('.card-product--image-slide');
  
    if (swipeTrack && bullets.length && slides.length) {
      const updatePagination = () => {
        // Determine the active slide based on scroll position
        const trackScrollLeft = swipeTrack.scrollLeft;
        const trackWidth = swipeTrack.clientWidth;
  
        slides.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft;
          const slideWidth = slide.offsetWidth;
          const scrollAmount = Math.round(slideWidth / 2);
  
          if (
            trackScrollLeft >= slideLeft - scrollAmount &&
            trackScrollLeft < slideLeft + scrollAmount
          ) {
            // Update active class on bullets
            bullets.forEach((bullet) => bullet.classList.remove('active'));
            const bullet = container.querySelector(`.product-card--pagination-bullet[data-value="${index + 1}"]`);
            if (bullet) bullet.classList.add('active');
          }
        });
      };
  
      // Attach scroll event listener to update pagination
      swipeTrack.addEventListener('scroll', updatePagination);
  
      // Initial update on page load
      updatePagination();
    }
  });
  
  // Swipable product cards - Arrows
  document.querySelectorAll('.card-product--image-swipe-container').forEach(function (container) {
    const swipeTrack = container.querySelector('.card-product--image-swipe-track');
    const arrowLeft = container.querySelector('.pcpa-left');
    const arrowRight = container.querySelector('.pcpa-right');

    if (swipeTrack && arrowLeft && arrowRight) {      
      // Add click event listener for left arrow
      arrowLeft.addEventListener('click', function (event) {
        event.preventDefault();
        const slide = swipeTrack.querySelector('.card-product--image-slide');
        const slideWidth = slide ? slide.offsetWidth : 100;
        const swipeAmount = Math.round(slideWidth / 1);
        swipeTrack.scrollBy({ left: -swipeAmount, behavior: 'smooth' });
      });

      // Add click event listener for right arrow
      arrowRight.addEventListener('click', function (event) {
        event.preventDefault();
        const slide = swipeTrack.querySelector('.card-product--image-slide');
        const slideWidth = slide ? slide.offsetWidth : 100;
        const swipeAmount = Math.round(slideWidth / 1);
        swipeTrack.scrollBy({ left: swipeAmount, behavior: 'smooth' });
      });

      // Add scroll event listener to update arrow states dynamically
      swipeTrack.addEventListener('scroll', function () {
        updateCardArrowState(arrowLeft, arrowRight, swipeTrack);
      });

      // Initial arrow state update on page load
      updateCardArrowState(arrowLeft, arrowRight, swipeTrack);
    }
  });  
}

// Call the function on page load
initializeSwipeFunctionality();

